// AdminUser.role enum — mirrors the backend `AdminUser.Role` TextChoices
// (apps/backend/core/models.py, PRD-32). The string values ARE the wire
// contract; the UI maps each to an es-MX / en-US label via
// `admin-users:role.<value>`.
//
// Three-tier model (PRD-32 §FR-1):
//   - PLATFORM_SUPERUSER — Platonica staff; manages any institution + grants
//     any role (restricted to @platonica.io and @sumus.mx emails, enforced
//     server-side).
//   - INSTITUTION_ADMIN — manages only its own institution's schools /
//     professors / admin-users; may NOT create institutions or grant
//     PLATFORM_SUPERUSER.
//   - VIEWER — read-only.

export const ADMIN_ROLES = ["platform_superuser", "institution_admin", "viewer"] as const
export type AdminRole = (typeof ADMIN_ROLES)[number]

export const ROLE = {
  platformSuperuser: "platform_superuser",
  institutionAdmin: "institution_admin",
  viewer: "viewer",
} as const

/** Platform superusers see the cross-institution "Instituciones" surface and
 *  may onboard new customers. */
export function isPlatformSuperuser(role: AdminRole | undefined): boolean {
  return role === ROLE.platformSuperuser
}

/** Institution admins and platform superusers may create / edit / soft-delete /
 *  restore within their scope. Viewers are read-only. */
export function canManage(role: AdminRole | undefined): boolean {
  return role === ROLE.platformSuperuser || role === ROLE.institutionAdmin
}
